import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconPriceStyle0 = stylesCss;

const BiIconPrice$1 = /*@__PURE__*/ proxyCustomElement(class BiIconPrice extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '2a15bca6434c3bffe53808d73a37c6e1edd27b8e', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '8d14fbf5b4249d2d13f4c88d7a7e6f3dbddd20a9', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'ee66b7280d90d99583a89c65299e71339fbaf7bc', "fill-rule": 'evenodd', d: 'M3.875 3.575h9.3l7.728 7.729a3.248 3.248 0 0 1 0 4.59l-4.708 4.708a3.248 3.248 0 0 1-4.59 0l-7.73-7.728v-9.3Zm1.5 1.5v7.177l7.29 7.29c.68.68 1.788.68 2.47 0l4.707-4.709a1.75 1.75 0 0 0 0-2.469l-7.29-7.29H5.376ZM8.54 8.32a.081.081 0 1 0 0-.162.081.081 0 0 0 0 .162m-1.42-.08a1.419 1.419 0 1 1 2.839 0 1.419 1.419 0 0 1-2.838 0Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconPriceStyle0; }
}, [1, "bi-icon-price", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-price"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-price":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconPrice$1);
            }
            break;
    } });
}

const BiIconPrice = BiIconPrice$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconPrice, defineCustomElement };
